import * as React from 'react';
import {Container, Title} from './styles';
import {theme} from '../../../../styles/darkTheme'; //Temporal

interface ButtonProps {
  children: React.ReactNode;
  backgroundColor?: string;
  shadowColor?: string;
  disabled?: boolean;
  textColor?: string;
  onClick: () => void;
  validation?: boolean;
  className?: any;
  submit?: boolean;
}

const Button: React.FC<ButtonProps> = ({
  children,
  backgroundColor,
  shadowColor,
  disabled,
  textColor,
  onClick,
  validation,
  className,
  submit = false,
}) => {
  const handleClick = () => {
    if (!disabled) onClick();
  };
  return (
    <Container
      className={className}
      backgroundColor={backgroundColor}
      shadowColor={shadowColor}
      disabled={disabled}
      onClick={handleClick}
      theme={theme}
      type={submit ? 'submit' : 'button'}
      validation={validation}>
      <Title theme={theme} color={textColor}>
        {children}
      </Title>
    </Container>
  );
};

export default Button;
